module.exports = __webpack_public_path__ + "static/media/truebytlc-logo.27afb80a.svg";